import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import {
  Box,
  Typography,
  TextField,
  Container,
  InputAdornment,
  styled,
} from '@mui/material';
import { FiSearch } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

// LearningDiscovery stílusok
const StyledContainer = styled(Container)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
  transition: 'background 0.3s ease-in-out',
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(4),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '4.0rem',
  },
  animation: 'fadeIn 0.8s ease-in',
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  maxWidth: '600px',
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(1),
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    },
    '&.Mui-focused': {
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(2),
    fontSize: '1.1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      padding: theme.spacing(1.5),
    },
  },
}));

const SearchIcon = styled(FiSearch)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: '1.5rem',
}));

const VGP: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token');
  const [searchValue, setSearchValue] = useState<string>('');
  const [randomTitle, setRandomTitle] = useState<string>('');
  const navigate = useNavigate();


  // Véletlenszerű főcím szinonimák
  const titleSynonyms = [
    "Discover",
    "Master",
    "Explore",
    "Dive Into",
    "Unlock"
  ];

  // Véletlenszerű placeholder szöveg
  const placeholderTexts = [
    "Discover skills, topics or paths...",
    "Search knowledge universe...",
    "Find your next challenge...",
    "What will you conquer today?",
    "Type your learning quest..."
  ];
  const [placeholder, setPlaceholder] = useState<string>('');

  // Véletlenszerű cím stílus
  const titleStyles: React.CSSProperties[] = [
    { fontFamily: 'Roboto, sans-serif', fontStyle: 'normal'},
    { fontFamily: '"Courier New", monospace', fontStyle: 'italic'},
    { fontFamily: 'Montserrat, sans-serif', fontStyle: 'normal'},
    { fontFamily: '"Times New Roman", serif', fontStyle: 'oblique'},
    { fontFamily: 'Georgia, serif', fontStyle: 'italic'},
  ];
  const [titleStyle, setTitleStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    // Véletlenszerű placeholder kiválasztása mountoláskor
    const randomPlaceholder =
      placeholderTexts[Math.floor(Math.random() * placeholderTexts.length)];
    setPlaceholder(randomPlaceholder);

    // Véletlenszerű elemek kiválasztása
    const randomTitle = titleSynonyms[Math.floor(Math.random() * titleSynonyms.length)];
    setRandomTitle(randomTitle);

    // Véletlenszerű cím stílus kiválasztása mountoláskor
    const randomTitleStyle =
      titleStyles[Math.floor(Math.random() * titleStyles.length)];
    setTitleStyle(randomTitleStyle);
  }, []);

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchValue(event.target.value);
  };

  // Search form submit handler
  const handleSearchSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Csak navigálunk, az API hívást a Learning oldalban végezzük el
    navigate('/learning', { state: { searchInput: searchValue } });
  };
  

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Háttér: Particles komponens */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
        }}
      >
        <Particles />
      </div>

      {/* Navigációs sáv */}
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      {/* LearningDiscovery keresési felület */}
      <StyledContainer maxWidth="lg">
        <Box
          component="main"
          role="main"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <StyledTypography
            variant="h1"
            aria-label="Explore learning"
            style={titleStyle}
          >
             {randomTitle} Learning Paths
          </StyledTypography>
          <form onSubmit={handleSearchSubmit} style={{ width: '100%', maxWidth: '600px' }}>
            <StyledTextField
              fullWidth
              placeholder={placeholder}
              variant="outlined"
              value={searchValue}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
                'aria-label': placeholder,
              }}
            />
          </form>
        </Box>
      </StyledContainer>
    </div>
  );
};

export default VGP;
